import React from "react";

export const BlockedComponent: React.FunctionComponent = (): React.ReactElement => {
    return <p>This component is blocked for security reasons</p>;
}